<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.6665 12H11.3332C12.0696 12 12.6665 11.403 12.6665 10.6667V3.33333C12.6665 2.59695 12.0696 2 11.3332 2H5.99984C5.26346 2 4.6665 2.59695 4.6665 3.33333V4M10.6665 12H5.99984C5.26346 12 4.6665 11.403 4.6665 10.6667V4M10.6665 12V12.6667C10.6665 13.403 10.0696 14 9.33317 14H3.99984C3.26346 14 2.6665 13.403 2.6665 12.6667V5.33333C2.6665 4.59695 3.26346 4 3.99984 4H4.6665"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
